<!-- Sidebar Header starts -->
<div id="sidebar-wrapper" class="sidebar">
    <div class="brand-logo" style="cursor: pointer;">
        <a (click)="goToDashboard()">
            <img src="assets/images/q_logo_old.png" class="logo-icon" alt="logo icon">
            <h5 class="logo-text">Agnext Qualix 1.0</h5>
        </a>
    </div>
    <!-- <div class="sidebar-header">
        <p class="mb-0">MAIN NAVIGATION</p>
    </div> -->
    <!-- Sidebar Header Ends -->


    <!-- Sidebar Content starts -->
    <div class="sidebar-content" [perfectScrollbar]>
        <ul id="active-class" class="navigation">
            <!-- Nothing to navigate to for this login -- link back to the landing
                 page (same as clicking the logo) instead of leaving the list empty. -->
            <li *ngIf="menuItems.length === 0" (click)="goToDashboard()">
                <a>
                    <i class="zmdi zmdi-home"></i>
                    <span class="menu-title">Home</span>
                </a>
            </li>
            <!-- First level menu -->
            <li *ngFor="let menuItem of menuItems" [ngClass]="[menuItem.class]"  (click)="goToChild($event,menuItem);"
                [routerLinkActive]="menuItem.submenu.length != 0 ? '' : 'active'"
                [routerLinkActiveOptions]="{exact: true}">
                <ng-container *ngIf="menuItem.accessPermission && !menuItem.deninedPermission">
                    <a [routerLink]="menuItem.class === '' ? [menuItem.path] : null"
                        *ngIf="!menuItem.isExternalLink; else externalLinkBlock">
                        <i [ngClass]="[menuItem.icon]"></i>
                        <span class="menu-title">{{menuItem.title}}</span>
                        <span *ngIf="menuItem.badge != '' " [ngClass]="[menuItem.badgeClass]">{{menuItem.badge}}</span>
                    </a>
                    <ng-template #externalLinkBlock>
                        <a [href]="[menuItem.path]" target="_blank">
                            <i [ngClass]="[menuItem.icon]"></i>
                            <span class="menu-title">{{menuItem.title}}</span>
                            <span *ngIf="menuItem.badge != '' "
                                [ngClass]="[menuItem.badgeClass]">{{menuItem.badge}}</span>
                        </a>
                    </ng-template>
                    <!-- Second level menu -->
                    <ul class="menu-content" *ngIf="(menuItem.submenu.length > 0 &&  menuItem.accessPermission)">
                        <li *ngFor="let menuSubItem of menuItem.submenu"  (click)="$event.stopPropagation();"
                            [routerLinkActive]="menuSubItem.submenu.length > 0 ? '' : 'active'"
                            [ngClass]="[menuSubItem.class]">
                            <ng-container *ngIf="menuSubItem.accessPermission">
                                <div *ngIf="
                                menuSubItem.title === 'NewDashboard'
                                    ? menuSubItem.environment === environment
                                        ? true
                                        : false
                                    : true">
                                    <a [routerLink]="menuSubItem.submenu.length > 0 ? null : [menuSubItem.path]"
                                        *ngIf="!menuSubItem.isExternalLink; else externalSubLinkBlock">
                                        <i [ngClass]="[menuSubItem.icon]"></i>
                                        <span class="menu-title">{{menuSubItem.title}}</span>
                                        <span *ngIf="menuSubItem.badge != '' "
                                            [ngClass]="[menuSubItem.badgeClass]">{{menuSubItem.badge}}</span>
                                    </a>
                                </div>
                            </ng-container>
                            <ng-template #externalSubLinkBlock>
                                <a [href]="[menuSubItem.path]">
                                    <i [ngClass]="[menuSubItem.icon]"></i>
                                    <span class="menu-title">{{menuSubItem.title}}</span>
                                    <span *ngIf="menuSubItem.badge != '' "
                                        [ngClass]="[menuSubItem.badgeClass]">{{menuSubItem.badge}}</span>
                                </a>
                            </ng-template>
                        </li>

                    </ul>
                </ng-container>
            </li>
        </ul>
    </div>
    <!-- Sidebar Content Ends -->
</div>